module.exports = __webpack_public_path__ + "img/close.1bd62eb7.svg";